import { FC, Fragment } from "react";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Box,
  Button,
  Container,
  Typography,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import UndoIcon from "@mui/icons-material/Undo";

interface DigitalSignatures {
  fileName: string;
  digitalSignature: {
    success: boolean;
    message?: string;
    signatures: DigitalSignature[];
  };
  resetFileSelected: () => void;
}

interface DigitalSignature {
  signed_with_smartpass: boolean;
  signed_by: string;
  signed_at: string;
  signed_at_timesamp: string;
  signature_embedded: DigitalSignatureEmbbed;
}

interface DigitalSignatureEmbbed {
  "Signer info": string;
  Integrity: string;
  "Signing time": string;
  Modifications: string;
}

export const FileDetails: FC<DigitalSignatures> = ({
  fileName,
  digitalSignature,
  resetFileSelected,
}) => {
  return (
    <Box
      className="row"
      sx={{
        width: 1,
      }}
    >
      {digitalSignature.signatures.length > 0 ? (
        <Fragment>
          <Typography my={2} align="center" variant="h6">
            <strong>Documento:</strong> {fileName}
          </Typography>
          <Typography my={2} align="center" variant="h5">
            Detalhe das Assinaturas
          </Typography>
          {digitalSignature.signatures.map((signature) => {
            return (
              <Accordion key={signature.signed_at_timesamp}>
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                  <Typography
                    component={"span"}
                    display="inline-block"
                    sx={{ mr: 1, flexShrink: 0 }}
                  >
                    Assinado por:
                  </Typography>
                  <Typography
                    component={"span"}
                    display="inline-block"
                    sx={{ color: "text.secondary" }}
                  >
                    {signature.signed_by}
                  </Typography>
                  {signature.signed_with_smartpass && (
                    <Typography
                      component={"span"}
                      display="inline-block"
                      sx={{ ml: 1 }}
                      align="right"
                    >
                      <img
                        src="/images/smartpass-logo.png"
                        alt="logo"
                        height={20}
                      />
                    </Typography>
                  )}
                </AccordionSummary>
                <AccordionDetails>
                  <Typography component={"span"} display="inline-block">
                    <Container
                      key={signature.signed_at_timesamp}
                      sx={{
                        borderTop: (theme) =>
                          `1px solid ${theme.palette.divider}`,
                      }}
                    >
                      <Typography component={"span"} display="inline-block">
                        <strong>Assinado por:</strong> {signature.signed_by}
                      </Typography>
                      <br />
                      <Typography component={"span"} display="inline-block">
                        <strong>Data da assinatura:</strong>{" "}
                        {signature.signed_at}
                      </Typography>
                      <Accordion
                        sx={{
                          backgroundColor: "whitesmoke",
                        }}
                      >
                        <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                          <Typography
                            component={"span"}
                            display="inline-block"
                            variant="subtitle1"
                          >
                            <strong>Mais detalhes</strong>
                          </Typography>
                        </AccordionSummary>
                        <AccordionDetails>
                          <Typography
                            component={"span"}
                            display="inline-block"
                            mb={1}
                          >
                            <strong>Integridade:</strong>{" "}
                            {signature.signature_embedded.Integrity}
                          </Typography>
                          <Typography
                            component={"span"}
                            display="inline-block"
                            mb={1}
                          >
                            <strong>Informações do assinante:</strong>{" "}
                            {signature.signature_embedded["Signer info"]}
                          </Typography>
                          <Typography component={"span"} display="inline-block">
                            <strong>Hora de assinatura:</strong>{" "}
                            {signature.signature_embedded["Signing time"]}
                          </Typography>
                        </AccordionDetails>
                      </Accordion>
                    </Container>
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
          <Typography align="center" my={3}>
            <Button
              component="label"
              variant="contained"
              startIcon={<UndoIcon />}
              size="large"
              onClick={() => resetFileSelected()}
            >
              Validar outro documento
            </Button>
          </Typography>
        </Fragment>
      ) : (
        <Fragment>
          <Typography my={2} align="center">
            <Alert severity="warning">Nenhuma assinatura encontrada.</Alert>
          </Typography>
        </Fragment>
      )}
    </Box>
  );
};
